<template>
  <div class="video-popup" >
    <div class="video-content">
      <img v-show="!isShowVideo" :src="coverUrl" alt="">
      <video v-show="isShowVideo" ref="myVideo" 
             :controls="!fullScreenPlay"
             :src="videoUrl"
             @fullscreenchange="handleFullscreenChange"
             @play="notFullScreenPlay"
             @ended="notFullScreenEnded"
             :poster="coverUrl"
             controlsList="nodownload noremoteplayback noplaybackrate"
             disablePictureInPicture
             playsinline
             x-webkit-airplay
             x5-video-player-type="h5"
             x5-videoplayer-fullscreen
             webkit-playsinline
             x5-video-orientation='portraint'
             style='object-fit:fill;'
      ></video>
      <div v-show="!notFullScreenVideoPlaying || fullScreenPlay" class="videoPlayBtn" @click="onChangeVideoPlay">
        <img class="videoBtn" src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        <div v-if="isShowTextBtn" class="videoTextBtn">
          <img src="https://resource.rcclchina.com.cn/paySuccess/videoTextBtnBlack.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    videoUrl:{
      type: String,
      default: ''
    },
    coverUrl:{
      type: String,
      default: ''
    },
    isShowTextBtn:{
      type: Boolean,
      default: false
    },
    // 全屏播放
    fullScreenPlay: {
      type: Boolean,
      default: false
    },
    // 是否切换
    isChange: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isFullscreen: false,
      isShowVideo: false,
      notFullScreenVideoPlaying: false
    }
  },
  mounted() {
  },
  watch:{
    videoUrl(newValue){
      console.log('videoUrlvideoUrl',newValue)
    },
    isChange(val) {
      if(val) {
        this.notFullScreenVideoPlaying = false;
        this.isShowVideo = false;
        if (this.$refs.myVideo) {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }
      }
    }
  },
  methods:{
    //   全屏
    async fullScreen() {
      if(this.fullScreenPlay) {
        // 自动播放
        const video = this.$refs.myVideo;
        // 点击播放按钮重新添加视频url
        this.isShowVideo = true
        video.setAttribute('src',this.videoUrl)
        this.onChangeVideoEmit()
        await video.play();
        if (!this.isFullscreen) {
          await this.enterFullscreen();
        } else {
          this.exitFullscreen();
        }
      } else {
        const video = this.$refs.myVideo;
        this.isShowVideo = true;
        video.setAttribute('src', this.videoUrl);
        this.onChangeVideoEmit();
        setTimeout(() => {
          video.play();
        }, 100);
      }
    },
    // 进入全屏逻辑
    async enterFullscreen() {
      const video = this.$refs.myVideo;
      await video.play()
      if (video.requestFullscreen) {
        await video.requestFullscreen();
      } else if (video.mozRequestFullScreen) { // Firefox
        await video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
        await video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) { // IE/Edge
        await video.msRequestFullscreen();
      }
    },
    // 退出全屏逻辑
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isFullscreen = false;
    },
    handleFullscreenChange() {
      // 更新全屏状态
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      if(!this.isFullscreen){
        this.isShowVideo = false
        this.$refs.myVideo.pause()
      //   清除视频显示出封面
        this.$refs.myVideo.setAttribute('src','')
      }
    },
    onChangeVideoPlay(){
      this.fullScreen()
    },
    // 播放视频触发事件
    onChangeVideoEmit(){
      this.$emit('onChangeVideo')
    },
    // 非全屏播放
    notFullScreenPlay() {
      console.log('notFullScreenPlay', this.notFullScreenVideoPlaying)
      this.notFullScreenVideoPlaying = true;
      this.isShowVideo = true;
      console.log('notFullScreenPlay', this.notFullScreenVideoPlaying)
    },
    notFullScreenEnded() {
      this.notFullScreenVideoPlaying = false;
      this.isShowVideo = false;
    }
  }
}
</script>
<style scoped lang="less">
.video-popup{
  width: 100%;
  height: 100%;
}
.video-content{
  width: 100%;
  height: 100%;
  position: relative;
  & video{
    width: 100%;
    height: 100%;
    display: block;
  }
  & img{
    width: 100%;
    height: 100%;
    display: block;
  }
  & .videoPlayBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 30px;
    align-items: center;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 100;
    & .videoBtn{
      width: 53px;
      height: 53px;
      display: block;
    }
    & .videoTextBtn{
      width: 200px;
      height: 45px;
      margin: 0 auto;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>